module.exports = __webpack_public_path__ + "img/fontawesome-webfont.eot?674f50d287a8c48dc19ba404d20fe713";


//////////////////
// WEBPACK FOOTER
// ./src/assets/plugins/font-awesome/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 593
// module chunks = 0